import React, { useState, useContext, useEffect } from 'react';
import {AppBar, Box, Drawer, IconButton, Typography, Badge, Popover, ListItem, ListItemIcon, Icon, ListItemText, Breadcrumbs } from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useSelector } from 'react-redux';
import Sidemenu from './sidemenu';
import { config } from '../../App';
import SideMenuAccount from 'common/headers/side-menu-account';
import HeaderBreadCrumb from './breadcrumbs';
import { useNavigate, useParams, useLocation } from "react-router-dom";

const Header = (props) => {
    const params = useParams();
    let location = useLocation();
    const userDetails = JSON.parse(localStorage.getItem('tirefaxUserDetails'));
    const [anchorEl, setAnchorEl] = useState(null);
    const {signIn, signout} = useContext(config);
    const {paths, setPaths} = useState([])
    const alerts = useSelector(state=>state.chat?.messages);
    const [state, setState] = useState({sidemenu: false, myAccount: false});
    const [menus, setMenus] = useState({
        menu: [
            {title: 'My Jobs', secTitle: 'Dui accumsan sit amet nulla.', onclick: '/list/jobs/active', admin: true, icon: 'add_circle'},
            {title: 'My Account', secTitle: 'Arcu dictum varius duis at.', onclick: '/account/profile/view', admin: true, icon: 'add_circle'},
        ],
        myAccount: [
            {title: 'PrivateDB Management', secTitle: 'Manage PrivateDB.', onclick: '/privatedb/list', admin: true, icon: 'add_circle'},
            {title: 'User Management', secTitle: 'Arcu dictum varius duis at.', onclick: '/users', admin: true, icon: 'add_circle'},
            {title: 'Organization Management', secTitle: 'Arcu dictum varius duis at.', onclick: '/orgs/list', admin: true, icon: 'add_circle'},
            {title: 'UsTires Management', secTitle: 'Manage PrivateDB.', onclick: '/ustires/list', admin: true, icon: 'add_circle'},
            {title: 'DOT Rearch Management', secTitle: 'Manage PrivateDB.', onclick: '/privatedb/list', admin: true, icon: 'add_circle'},
        ]
    })



    const openMenu = () =>{
        setState({...state, sidemenu: true});
    }

    const myAccount = (event) =>{
        setState({...state, myAccount: true});
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
    
    const closeMenu = (navigate) =>{
        setState({...state, sidemenu: false, myAccount: false});
    }

    const handleClose = () => {
        setAnchorEl(null);
      };

    const navProps = {
        closeMenu: closeMenu,
        myAccount: menus.myAccount,
        signout: signout,
        email: signIn.email,
        firstName: signIn.firstName,
        lastName: signIn.lastName,
        phone: signIn.phone, 
        orgName: signIn.orgName
    }
    const welcomeMessage = () =>{
        switch(signIn.userType){
            case 'client':
            case 'hauler':
                return signIn.email ? `Welcome, ${signIn.firstName || ''} ${signIn.lastName || ''}` : '';
            break;
            case 'org':
                return signIn.orgName ? `Welcome, ${signIn.orgName || ''} Admin` : '';
            break;
            case 'admin':
                return signIn.email ? `Welcome, Super Admin` : '';
            break;
            default:
                return '';
            break;
        }
    }

    return(
        <React.Fragment>
            <AppBar>
                {userDetails?.isAuthenticated? 
                    <Box pr={1} component="span" display="flex" justifyContent="space-between" alignItems="center">
                        <Box component="span" display="flex" justifyContent="flex-start" alignItems="center">
                            <IconButton size="small" onClick={openMenu}
                                sx={{
                                    fontWeight: 600,
                                    color: "#fff"
                                }}
                            >
                                <MenuRoundedIcon fontSize="inherit"/></IconButton>
                            <Typography align="left" variant='h5' 
                                sx={{
                                    margin: "10px",
                                    fontSize: "24px"
                                }}
                            >Control Panel</Typography>
                        </Box>
                        <Box component="span" display="flex" justifyContent="flex-end" alignItems="center" 
                            sx={{
                                marginRight: '20px',
                                marginLeft: '20px'
                            }}
                        >
                            <Badge badgeContent={alerts?.length} color="secondary" 
                                sx={{
                                    marginRight: '20px',
                                    marginLeft: '20px'
                                }}
                            >
                                <NotificationsIcon onClick={handleClick} 
                                    sx={{
                                        cursor: 'pointer'
                                    }}
                                />
                            </Badge>
                            <AccountCircleIcon fontSize="large" onClick={myAccount} />
                        </Box> 
                    </Box>
                :
                    <Box pr={1} component="span" display="flex" justifyContent="flex-start" alignItems="center">
                        <Typography align="left" variant='body1'
                            sx={{
                                margin: "10px!important",
                                fontSize: "24px",
                            }}
                        >TireFax</Typography>
                    </Box>            
                }
                <Box pr={1} component="span" display="flex" justifyContent="space-between" alignItems="center" 
                    sx={{
                        padding:".25rem",
                        backgroundColor: "#bdbdbd !important"
                    }}
                >
                    <Typography align="left" 
                        sx={{
                            fontSize: "12px",
                            fontWeight: "normal"
                        }}
                    >Admin Panel</Typography>
                    <Typography align="left" >{welcomeMessage()}</Typography>
                </Box>
                <Box pr={1} component="span" display="flex" justifyContent="space-between" alignItems="center" 
                    sx={{
                        padding:"10px",
                        backgroundColor: "#fff !important"
                    }}
                >
                    <HeaderBreadCrumb />
                </Box>
            </AppBar>
            {alerts?.length>0 ? <Popover  
                id="simple-menu"
                anchorEl={anchorEl} 
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
            >
                {alerts.map((a, i)=>
                    <ListItem key={i} button
                        sx={{
                            minWidth: '300px',
                        }}
                    >
                        <ListItemIcon 
                            sx={{
                                minWidth: '40px'
                            }}
                        >
                            <Icon color='secondary'>chat_icon</Icon>
                        </ListItemIcon>
                        <ListItemText primary={`New Message From ${a.authorType}`} secondary={`JOBID: ${a.id}`}/>
                    </ListItem>
                )}
            </Popover>:''}
            <Drawer open={state.sidemenu} onClose={()=>closeMenu(false)}><Sidemenu value={navProps}/></Drawer>
            <Drawer open={state.myAccount} anchor='right' onClose={()=>closeMenu(false)}><SideMenuAccount value={navProps}/></Drawer>
        </React.Fragment>
    )
}


export default Header;
